import { MagnifyIcon } from './MagnifyIcon';

/**
 * author: Google
 * id C2889545-7F08-4AE1-9142-ECF9B79957E1
 * name magnify
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magnify.svg
 * tags
 * - Geographic Information System 
 */
export const SearchIcon = MagnifyIcon;
export default SearchIcon